import _forEach from 'lodash/forEach';
import _isEmpty from 'lodash/isEmpty';

/* This is to parse all query string params into key value pair from the given url  */
export const parseQueryString = (url) => {
    const query = {};
    !_isEmpty(url) &&
        url.replace(/^.*\?/, '').replace(/([^=]+)=([^&]*)&?/g, (_match, key, value) => {
            query[key] = decodeURIComponent(value.replace('+', ' '));
            return '';
        });
    return query;
};

/* This is to identify which microsite pattern */
export const patterns = {
    GALLERY: /\/g(?=\/|\?).*/g,
    PDP: /\/p(?=\/|\?).*/g,
    SEARCH: /\/s/ || /\/s(?=\/|\?).*/g,
    DEPARTMENT: /\/d(?=\/|\?).*/g,
    v1patterns: {
        gallery: {
            pattern: '\\/N-*',
            flags: 'g',
        },
        search: {
            pattern: 'Ntt=*',
            flags: 'g',
        },
    },
};

/* This is to identify pagetype based on url */
export const getPageType = (url) => {
    let pageType = null;
    const gPatt = new RegExp(patterns.GALLERY);
    const sPatt = new RegExp(patterns.SEARCH);
    const dPatt = new RegExp(patterns.DEPARTMENT);
    const pPatt = new RegExp(patterns.PDP);
    if (gPatt.test(url)) {
        pageType = 'g';
    } else if (sPatt.test(url)) {
        pageType = 's';
    } else if (dPatt.test(url)) {
        pageType = 'd';
    } else if (pPatt.test(url)) {
        pageType = 'p';
    }
    return pageType;
};

/* This is to remove given query parameter and its value from the given url 
if removeAllParams true it will remove all params from url
*/
export const removeURLParameter = (param, url, removeAllParams = false) => {
    if ((!removeAllParams && _isEmpty(param)) || _isEmpty(url)) return url;
    const updatedUrl = decodeURIComponent(url).split('?');
    if (removeAllParams && updatedUrl.length >= 0) return updatedUrl[0];
    let path = updatedUrl.length === 1 ? '' : updatedUrl[1];
    path = path.replace(new RegExp(`&?${param}\\[\\d*\\]=[\\w]+(\\|*\\w+)`, 'g'), '');
    path = path.replace(new RegExp(`&?${param}=[^&]+`, 'g'), '');
    path = path.replace(/^&/, '');
    return updatedUrl[0] + (path.length ? `?${path}` : '');
};

/* This is to construct default SEO canonical Url if canonical Url not defined in iris 
   here default SEO canonical Url built based on excludeQueryParams or includeQueryParams

   if excludeQueryParams has given part of config -> preferences -> seoConfig -> excludeQueryParams
   then except these params remaining all will considered for SEO canonical url

   if includeQueryParams has given part of config -> preferences -> seoConfig -> includeQueryParams
   then only include these params remaining all params will be excluded for SEO canonical url

   except PDP and PLP for remaining TOF microsites we need to remove all parameters
   if both excludeQueryParams and includeQueryParams has given then return default url as is as this is invalid
*/
export const constructSEODefaultCanonicalUrl = (
    url = '',
    excludeQueryParams = [],
    includeQueryParams = [],
    removeAllParams = false
) => {
    try {
        let updatedUrl = url;
        // if both includeQueryParams && excludeQueryParams has given which is invalid and return url as is when removeAllParams is false
        if (
            (!removeAllParams &&
                ((!_isEmpty(includeQueryParams) && !_isEmpty(excludeQueryParams)) ||
                    (_isEmpty(includeQueryParams) && _isEmpty(excludeQueryParams)))) ||
            _isEmpty(updatedUrl)
        ) {
            return updatedUrl;
        }
        if (removeAllParams) return removeURLParameter('', updatedUrl, removeAllParams);
        const query = parseQueryString(updatedUrl);
        const validQueryParams = [];
        _forEach(query, (val, key) => {
            if (!_isEmpty(excludeQueryParams) && excludeQueryParams.indexOf(key) === -1) {
                validQueryParams.push(key);
            } else if (!_isEmpty(includeQueryParams) && includeQueryParams.indexOf(key) !== -1) {
                validQueryParams.push(key);
            }
        });
        const queryParams = Object.entries(query) || [];
        // extract params which needs to be removed from url
        const invalidQueryParams = queryParams.filter((obj) => {
            return validQueryParams.indexOf(obj[0]) === -1;
        });
        _forEach(invalidQueryParams, (val) => {
            updatedUrl = removeURLParameter(val[0], updatedUrl, removeAllParams);
        });
        return updatedUrl;
    } catch (error) {
        /* istanbul ignore next */
        console.warn('constructQueryStringForSEOTags failed', error);
    }
    return '';
};
export default parseQueryString;
